export const config = {
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || 'https://bee-website-api.k8s.test.beegroup.app/api/v1/',
    BASE_PATH: process.env.REACT_APP_BASE_PATH || '/bee-reactjs-website'
}